<app-header></app-header>
<mat-divider></mat-divider>
<div class="container">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
